<template>
	<div class="tv-input-password input-content">
		<!-- label -->
		<div class="password-label">
			<p class="body-4">{{ label }}</p>
		</div>
		<!-- input and helpers container -->
		<div class="input-helper">
			<!-- input password -->
			<Password
				v-model="internalValue"
				:toggleMask="toggleMask"
				:required="required"
				:placeholder="placeholder"
				:feedback="feedback"
				:disabled="disabled"
				:class="{ error: error, disabled: disabled }"
				class="notranslate"
				translate="no"
				@input="handleInput"
				@keydown.enter="emitEnter"
			/>
			<span class="input-message-content">
				<!-- helper text -->
				<p v-if="!error" class="overline">
					{{ helperText }}
				</p>
				<!-- error text -->
				<div v-if="error" class="error-helper">
					<span class="material-symbols-outlined notranslate" translate="no">
						error
					</span>
					<p class="overline">
						{{ currentErrorText }}
					</p>
				</div>
			</span>
		</div>
	</div>
</template>

<script setup>
import { defineProps, ref, watch, computed, defineEmits } from 'vue'
import Password from 'primevue/password'
import { i18n } from '../../src/plugins/i18n'

const props = defineProps({
	label: {
		type: String,
		required: true,
	},
	helperText: {
		type: String,
		required: false,
		default: '',
	},
	errorText: {
		type: String,
		required: false,
		default: '',
	},
	toggleMask: {
		type: Boolean,
		required: false,
		default: false,
	},
	required: {
		type: Boolean,
		required: false,
		default: false,
	},
	placeholder: {
		type: String,
		required: false,
		default: '',
	},
	feedback: {
		type: Boolean,
		required: false,
		default: false,
	},
	invalid: {
		type: Boolean,
		required: false,
		default: false,
	},
	disabled: {
		type: Boolean,
		required: false,
		default: false,
	},
	enableValidation: {
		type: Boolean,
		required: false,
		default: true,
	},
})

const internalValue = ref('')

const regex = /^(?=.*[A-Z])(?=.*[!@#$%^&*(),.?":{}|<>\/#])(?=.{8,})/

const internalInvalid = ref(false)

watch(internalValue, (newValue) => {
	if (props.enableValidation) {
		internalInvalid.value = !regex.test(newValue)
	}
})

const error = computed(() => {
	return props.invalid || (props.enableValidation && internalInvalid.value)
})

const currentErrorText = computed(() => {
	if (props.errorText) {
		return props.errorText
	}
	if (!internalValue.value) {
		return i18n.global.t('register.passwordRequired')
	}
	if (internalValue.value.length < 8) {
		return i18n.global.t('register.invalidPassword')
	}
	if (!/[A-Z]/.test(internalValue.value)) {
		return i18n.global.t('register.invalidPassword')
	}
	if (!/[!@#$%^&*(),.?":{}|<>\/#]/.test(internalValue.value)) {
		return i18n.global.t('register.invalidPassword')
	}
	return ''
})

const emitValue = defineEmits(['update:modelValue', 'enter'])

const handleInput = () => {
	emitValue('update:modelValue', internalValue.value)
}

const emitEnter = () => {
	emitValue('enter')
}
</script>

<style scoped>
/* Añade tus estilos aquí */
</style>
